import { makeStyles } from '@mui/styles';
import TreeItem from 'apollo-react/components/TreeItem';
import TreeView from 'apollo-react/components/TreeView';
import React, { useState } from 'react';

import { useFormSelector } from '../../../../../custom-hooks';
import { getUITA } from '../../../../../utils/commonUtils';
import { getFormModel } from '../../../../selectors/common.selectors';
import { getInterActionOptions } from '../../../../selectors/editor.selectors';
import { getType } from '../../../../utils/actions/rule.actions.utils';
import { _find } from '../../../../utils/form-manager.utils';

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  treeContainer: {
    border: '1px solid #ccc',
    overflow: 'auto',
    backgroundColor: 'white',
    height: '100%',
  },
});

const InteractionModel = ({ change, select }) => {
  const classes = useStyles();

  const treeData = useFormSelector(getInterActionOptions);
  const formModel = useFormSelector(getFormModel);

  const [selectedNode, setSelectedNode] = useState(undefined);

  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.label}>
      {Array.isArray(nodes.children) ? nodes.children.map((node) => renderTree(node)) : null}
    </TreeItem>
  );

  const handleSelect = (e, nodeId) => {
    e.stopPropagation();

    const nodeValue = _find(treeData, 'nodeId', nodeId[0]);

    if (nodeValue) {
      setSelectedNode(nodeValue);
      handleSelectAction({ nodeValue, changeFn: selectedNode ? change : select });
    }
  };

  const handleSelectAction = ({ nodeValue, changeFn }) => {
    if (!changeFn) {
      return;
    }

    changeFn({
      type: getType({ formModel, value: nodeValue.value }),
      value: nodeValue.value,
    });
  };

  return (
    <div className={classes.mainContainer}>
      <div className={classes.treeContainer} ui-ta={getUITA('InteractionModel', 'section')}>
        <TreeView variant="folder" onNodeSelect={handleSelect} multiSelect>
          {treeData.map((node) => renderTree(node))}
        </TreeView>
      </div>
    </div>
  );
};

export default React.memo(InteractionModel);
